// import React, { useRef } from "react";
// import {
//   Table, TableBody, TableCell, TableContainer, TableRow,
//   LinearProgress, Typography, InputAdornment, TextField, Button
// } from "@material-ui/core";
// import { connect } from "react-redux";
// import { Link } from "react-router-dom";
// import SearchIcon from "@material-ui/icons/Search";

// import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
// import { BackButton } from "../../Utils/FormInputs/BackButton";
// import Label from "../../Utils/FormInputs/Label";
// import { Container } from "../../Utils/styledComponents";
// import { EnhancedTableHead, MuiPaper } from "../../Utils/Tables/CustomTable";
// import { formatAmount } from "../../Utils/formatAmount";
// import { titleCase } from "../../Utils/titleCaseFunction";
// import { ReusableSalesAndPurchaseHeader } from "./ReusableSalesAndPurchaseHeader";
// import { useProfitLossReport } from "./CustomHooks/useProfitLossReport";
// import { useExcelReports, usePdfReports } from "../Invoice/CustomHooks/useExcelReports";

// import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
// import { bindActionCreators } from "redux";
// // New imports for Sales Person filter
// import axios from "axios";
// import config from "../../../Helpers/config.json";
import React, { useRef, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  LinearProgress,
  Typography,
  InputAdornment,
  TextField,
  Button,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";

import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import { BackButton } from "../../Utils/FormInputs/BackButton";
import Label from "../../Utils/FormInputs/Label";
import { Container } from "../../Utils/styledComponents";
import { EnhancedTableHead, MuiPaper } from "../../Utils/Tables/CustomTable";
import { formatAmount } from "../../Utils/formatAmount";
import { titleCase } from "../../Utils/titleCaseFunction";
import { ReusableSalesAndPurchaseHeader } from "./ReusableSalesAndPurchaseHeader";
import { useProfitLossReport } from "./CustomHooks/useProfitLossReport";
import { useExcelReports, usePdfReports } from "../Invoice/CustomHooks/useExcelReports";

import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import { bindActionCreators } from "redux";

// Imports for Sales Person filter
import axios from "axios";
import config from "../../Helpers/config.json";


const headData = [
  { id: "date", label: "Date" },
  { id: "invoice", label: "Transaction" },
  { id: "customer", label: "Customer" },
  { id: "drug", label: "Medicine" },
  { id: "qty", label: "Qty" },
  { id: "total", label: "Sale Amount" },
  { id: "cost", label: "Cost" },
  { id: "profit", label: "Profit" },
  { id: "discount", label: "Discount" },
  { id: "type", label: "Sale Type" }, // ← NEW COLUMN
  { id: "sales_person", label: "Sales Person" }, // Optional: if you want to show it
];

const GeneralProfitLossReport = (props) => {
  const {
    loading,
    report,
    from_date,
    to_date,
    search,
    setSearch,
    handleChangeDate,
    loadMore,
    hasMore,
    per_page,
    // New props from hook (you'll need to add these in useProfitLossReport)
    setSalesPersonId,
    selectedSalesPerson, 
    salesPersons,           // ← Added
    salesPersonsLoading,      // ← Add
    setSelectedSalesPerson,   // ← Add
  } = useProfitLossReport();

  const { actions } = props;
  const csvRef = useRef();

  const { summary = {}, retail_summary = {}, wholesale_summary = {}, sales_details = [], pagination = {} } = report;
// Local state for sales persons dropdown
  // const [salesPersons, setSalesPersons] = useState([]);
  // const [selectedSalesPerson, setSelectedSalesPerson] = useState("");

  // // Fetch Sales Persons (Added as requested)
  // useEffect(() => {
  //   axios.get(`${config.epharmUrl}/admin/get_users_with_roles`)
  //     .then(res => {
  //       const data = res.data || [];
  //       const arr = data.map(person => ({
  //         value: person.user_id,
  //         label: `${person.first_name || ''} ${person.last_name || ''}`.trim() || person.email
  //       }));
  //       setSalesPersons(arr);
  //     })
  //     .catch(err => {
  //       console.error("Failed to fetch sales persons", err);
  //       // errorMessages(err, null, actions);
  //     });
  // }, []);

  const {
    total_sales = 0,
    total_discounts_given = 0,
    total_cost_of_goods = 0,
    total_expenses = 0,
    net_profit = 0,
    profit_margin_percent = 0,
    total_transactions = 0,
    returned_transactions = 0,
  } = summary;

  const {
    sales: retail_sales = 0,
    discounts: retail_discounts = 0,
    cogs: retail_cogs = 0,
    gross_profit: retail_profit = 0
  } = retail_summary;

  const {
    sales: wholesale_sales = 0,
    discounts: wholesale_discounts = 0,
    cogs: wholesale_cogs = 0,
    gross_profit: wholesale_profit = 0
  } = wholesale_summary;

  const csvData = sales_details.map((item) => ({
    date: item.date,
    transaction: item.is_receipt ? `R-${item.display_number}` : item.invoice,
    customer: item.customer,
    drug: item.drug,
    quantity: item.qty,
    sale_amount: item.total,
    cost: item.cost,
    profit: item.profit,
    discount: item.discount,
    sale_type: item.sale_type || "retail",
  }));

  const headers = [
    { key: "date", label: "Date" },
    { key: "transaction", label: "Transaction" },
    { key: "customer", label: "Customer" },
    { key: "drug", label: "Medicine" },
    { key: "quantity", label: "Qty" },
    { key: "sale_amount", label: "Sale Amount" },
    { key: "cost", label: "Cost" },
    { key: "profit", label: "Profit" },
    { key: "discount", label: "Discount" },
    { key: "sale_type", label: "Sale Type" },
    { key: "sales_person", label: "Sales Person" },
  ];

  const currentObj = { file_name: "Profit & Loss Report", url: "admin/general_profit_loss_excel", params: { start_date: from_date, end_date: to_date } };
  const objPDF = { file_name: "Profit & Loss Report", url: "admin/general_profit_loss_pdf", params: { start_date: from_date, end_date: to_date } };
  const { exportExcel } = useExcelReports(actions, currentObj);
  const { exportPDF } = usePdfReports(actions, objPDF);
// const handleSalesPersonChange = (e) => {
//     const value = e.target.value;
//     setSelectedSalesPerson(value);
//     // If your hook supports it:
//     if (setSalesPersonId) setSalesPersonId(value);
//     // Otherwise you'll need to trigger a refetch in useProfitLossReport
//   };
const handleSalesPersonChange = (e) => {
  setSelectedSalesPerson(e.target.value);
};
  return (
    <div className="journals">
      <ReusableDashboardHeader component="General Profit & Loss" heading="Reports" subHeading="Profit & Loss Summary" link="/general-profit-loss" />

      <Container>
        <div className="mb-3"><BackButton text="All Reports" to="/allreports" /></div>

        <ReusableSalesAndPurchaseHeader
          handleSubmit={(e) => e.preventDefault()}
          exportExcel={exportExcel}
          exportPdf={exportPDF}
          csvData={csvData}
          fetchCsvData={() => csvRef.current?.link.click()}
          csvRef={csvRef}
          headers={headers}
          csvTitle="Profit & Loss Report"
        >
          <div className="d-flex flex-wrap align-items-end gap-3">
            <div>
              <Label name="From Date" />
              <input type="date" className="form-control" value={from_date} name="from_date" onChange={handleChangeDate} />
            </div>
            <div>
              <Label name="To Date" />
              <input type="date" className="form-control" value={to_date} name="to_date" onChange={handleChangeDate} />
            </div>

            {/* === SALES PERSON FILTER === */}
            <div style={{ minWidth: 220 }}>
              <Label name="Sales Person" />
              <FormControl fullWidth size="small" variant="outlined">
                <Select
                  value={selectedSalesPerson}
                  onChange={handleSalesPersonChange}
                  displayEmpty
                >
                  <MenuItem value="">All Sales Persons</MenuItem>
                  {salesPersons.map(person => (
                    <MenuItem key={person.value} value={person.value}>
                      {person.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ minWidth: 300 }}>
              <Label name="Search (Invoice, Receipt, Drug, Customer)" />
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                }}
                placeholder="Search transactions..."
              />
            </div>
            <div>
              <span className="badge bg-primary fs-6">Per Page: {per_page}</span>
            </div>
          </div>
        </ReusableSalesAndPurchaseHeader>

        {/* === RETAIL vs WHOLESALE SUMMARY CARDS === */}
        <div className="row mt-4 g-4">
          {/* Retail Sales */}
          <div className="col-md-4">
            <div className="card border-start border-success shadow-sm h-100 py-3">
              <div className="card-body">
                <div className="text-xs font-weight-bold text-success text-uppercase mb-2">Retail Sales</div>
                <div className="h5 mb-2 fw-bold text-gray-800">{formatAmount(retail_sales)}</div>
                <div className="text-sm text-gray-600">
                  COGS: {formatAmount(retail_cogs)} | Profit: {formatAmount(retail_profit)}
                </div>
                <div className="text-sm text-gray-600">
                  Discount: {formatAmount(retail_discounts)} 
                </div>
              </div>
            </div>
          </div>

          {/* Wholesale Sales */}
          <div className="col-md-4">
            <div className="card border-start border-purple shadow-sm h-100 py-3">
              <div className="card-body">
                <div className="text-xs font-weight-bold text-purple text-uppercase mb-2">Wholesale Sales</div>
                <div className="h5 mb-2 fw-bold text-gray-800">{formatAmount(wholesale_sales)}</div>
                <div className="text-sm text-gray-600">
                  COGS: {formatAmount(wholesale_cogs)} | Profit: {formatAmount(wholesale_profit)}
                </div>
                <div className="text-sm text-gray-600">
                  Discount: {formatAmount(wholesale_discounts)} 
                </div>
              </div>
            </div>
          </div>

          {/* Overall Summary */}
          <div className="col-md-4">
            <div className={`card border-start ${net_profit >= 0 ? 'border-success' : 'border-danger'} shadow-sm h-100 py-3`}>
              <div className="card-body">
                <div className="text-xs font-weight-bold text-uppercase mb-2">Overall Net Profit</div>
                <div className={`h4 mb-2 fw-bold ${net_profit >= 0 ? 'text-success' : 'text-danger'}`}>
                  {formatAmount(net_profit)}
                </div>
                <div className="text-sm">
                  Margin: <strong>{profit_margin_percent.toFixed(1)}%</strong> | 
                  Expenses: {formatAmount(total_expenses)}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Summary Row */}
        <div className="row mt-3 g-3 text-sm">
          <div className="col-md-3">
            <div className="card bg-light">
              <div className="card-body py-2">
                <strong>Total Sales:</strong> {formatAmount(total_sales)}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-light">
              <div className="card-body py-2">
                <strong>Discounts Given:</strong> {formatAmount(total_discounts_given)}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-light">
              <div className="card-body py-2">
                <strong>Total COGS:</strong> {formatAmount(total_cost_of_goods)}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-light">
              <div className="card-body py-2">
                <strong>Transactions:</strong> {total_transactions.toLocaleString()}
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <MuiPaper className="mt-4">
          {loading && <LinearProgress />}

          <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
            <div>
              <strong>{returned_transactions.toLocaleString()}</strong> of <strong>{total_transactions.toLocaleString()}</strong> transactions shown
            </div>
            {hasMore && (
              <Button variant="contained" color="primary" onClick={loadMore} disabled={loading}>
                {loading ? "Loading..." : "Load More"}
              </Button>
            )}
          </div>

          <TableContainer>
            <Table size="small">
              <EnhancedTableHead headCells={headData} />
              <TableBody>
                {sales_details.length > 0 ? (
                  sales_details.map((item, i) => (
                    <TableRow hover key={i}>
                      <TableCell>{item.date}</TableCell>
                      <TableCell>
                        <Link
                          to={{
                            pathname: item.is_receipt
                              ? `/receipt_print/${item.customer_id}/${item.receipt_number || item.display_number}`
                              : `/invoice_print/${item.customer_id}/${item.invoice}`,
                          }}
                          style={{ color: item.is_receipt ? "#d4af37" : "#09905c", fontWeight: 600 }}
                        >
                          {item.is_receipt ? `R-${item.display_number}` : item.invoice}
                        </Link>
                      </TableCell>
                      <TableCell>{titleCase(item.customer || "-")}</TableCell>
                      <TableCell>{item.drug}</TableCell>
                      <TableCell align="right">{item.qty}</TableCell>
                      <TableCell align="right">{formatAmount(item.total)}</TableCell>
                      <TableCell align="right">{formatAmount(item.cost)}</TableCell>
                      <TableCell align="right" style={{ color: item.profit >= 0 ? "green" : "red", fontWeight: "bold" }}>
                        {formatAmount(item.profit)}
                      </TableCell>
                      <TableCell align="right">{formatAmount(item.discount)}</TableCell>
                      <TableCell>
                        <span className={`badge ${item.sale_type === 'wholesale' ? 'bg-info' : 'bg-success'} text-white`}>
                          {titleCase(item.sale_type || "retail")}
                        </span>
                      </TableCell>
                      <TableCell>{item.sales_person_name || "-"}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <Typography variant="body1" color="textSecondary">
                        No transactions found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </MuiPaper>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({ snackbars: state.snackbars });
const mapDispatchToProps = (dispatch) => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) },
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralProfitLossReport);